import { Alert, AlertTitle, Box, Collapse, Link, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useOrdersState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/orders-context';

const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.orders';

const ProductsUnavailableAlert: React.FC = () => {
  const theme = useTheme();
  const {
    recommendationAssortmentQuery: { data: recommendationAssortment },
  } = useOrdersState();

  const productsUnavailableAtPlant = recommendationAssortment?.productsUnavailableAtPlant ?? [];

  const [showUnavailableProducts, setShowUnavailableProducts] = useState(false);

  if (!productsUnavailableAtPlant.length) return null;

  return (
    <Alert sx={{ alignItems: 'flex-start', '& .MuiAlert-message': { width: '100%' } }} severity="warning">
      <AlertTitle>
        <FormattedMessage id={`${PAGE_NAME_ID}.list.productsUnavailableAtPlantTitle`} />
      </AlertTitle>
      <Box display={'flex'} flexDirection={'column'} gap={1}>
        <Typography variant="body2">
          <FormattedMessage id={`${PAGE_NAME_ID}.list.productsUnavailableAtPlantMessage`} />
        </Typography>
        <Box>
          <Link component="button" type="button" onClick={() => setShowUnavailableProducts((prev) => !prev)}>
            <FormattedMessage
              id={`${PAGE_NAME_ID}.list.productsUnavailableAtPlant${showUnavailableProducts ? 'Hide' : 'Show'}`}
              values={{ count: productsUnavailableAtPlant.length }}
            />
          </Link>
        </Box>
        <Collapse in={showUnavailableProducts}>
          <Box
            padding={4}
            width={'100%'}
            maxHeight={200}
            borderRadius={1}
            overflow={'auto'}
            border={`1px solid ${theme.palette.divider}`}>
            <Box component="ul" margin={0} paddingLeft={3}>
              {productsUnavailableAtPlant.map((product, index) => (
                <Typography component="li" variant="body2" key={`${product}-${index}`}>
                  {product}
                </Typography>
              ))}
            </Box>
          </Box>
        </Collapse>
        <Typography variant="body2">
          <FormattedMessage id={`${PAGE_NAME_ID}.list.productsUnavailableAtPlantInstruction`} />
        </Typography>
      </Box>
    </Alert>
  );
};

export default React.memo(ProductsUnavailableAlert);
